import { render, staticRenderFns } from "./partnerStudios.vue?vue&type=template&id=ccbbc0c8&scoped=true&"
import script from "./partnerStudios.vue?vue&type=script&lang=js&"
export * from "./partnerStudios.vue?vue&type=script&lang=js&"
import style0 from "./partnerStudios.vue?vue&type=style&index=0&id=ccbbc0c8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccbbc0c8",
  null
  
)

export default component.exports